import { getCountryName } from '@ovComponents/resources';
import { Typography } from 'hephaestus/web';

export const CountryName = ({ code }: { code: string }) => (
  <Typography variant='bodyLarge'>{getCountryName(code) || code}</Typography>
);
